import React from 'react'
import { CheckCircleOutline, Warning } from '@mui/icons-material'
import { convertToBrazilianCurrency } from 'utils/functions'
import InternFrame from 'components/InternFrame'
import Colors from 'utils/Colors'

import Container from './styles'

function BuildResumeBoard(props) {
  const { boardData, quantity, totalAmount } = props

  const getIcon = (aproved) => {
    return aproved ?
      <CheckCircleOutline style={{ color: Colors.green }} /> :
      <Warning style={{ color: Colors.red }} />
  }

  return (
    <InternFrame title='Resumo'>
      <Container>
        <div>
          <span>
            {getIcon(boardData.serasa.length === 0)}
          </span>
          <span className='field'>Serasa: </span>
          {` ${boardData?.serasa.length} ocorrência(s)`}
        </div>
        <div>
          <span>
            {getIcon(boardData.spc.length === 0)}
          </span>
          <span className='field'>SPC: </span>
          {` ${boardData?.spc.length} ocorrência(s)`}
        </div>
        <div>
          <span>
            {getIcon(boardData.others.length === 0)}
          </span>
          <span className='field'>Outros: </span>
          {` ${boardData?.others.length} ocorrência(s)`}
        </div>
        <div>
          <span className='field'>Total: </span>
          {` ${quantity} ocorrência(s)`}
        </div>
        <div>
          <span className='field'>Valor Total: </span>
          {` ${convertToBrazilianCurrency(totalAmount)}`}
        </div>
      </Container>
    </InternFrame>
  )
}

export default BuildResumeBoard
